import Map, { MapRef, Marker, useMap } from 'react-map-gl';
import { RootState, useAppSelector } from '../../redux/AppStore';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

export default function DriverLiveLocationMapComponent() {
  const driverLcation = useAppSelector((state: RootState) => state.tracking.driverlocation);
  const trackingNumber = useAppSelector((state: RootState) => state.tracking.trackingNum);
  const trackingdata = useSelector((state: RootState) => state.tracking.trackingAddress.tracking_address);
  const [latitude, setlatitude] = useState<number>(0);
  const [lognitude, setlognitude] = useState<number>(0);
  const [status, setStatus] = useState({});
  const [driverlat, setdriverlat] = useState('');
  const [driverlong, setdriverlong] = useState('');
  useEffect(() => {
    for (let d of driverLcation) {
      if (d.driver_location.length != 0) {
        setdriverlat(d.driver_location.latitude);
        setdriverlong(d.driver_location.longitude);
      }
    }
  }, [driverLcation])
  useEffect(() => {
    for (let d of trackingdata) {
      if (d.group_type === "NEXT" && d.shipment_service_type === 'D' && d.load_identity === trackingNumber) {
        setlatitude(Number(d.shipment_latitude));
        setlognitude(Number(d.shipment_longitude));
        setStatus(d.current_status);
      } else if (d.group_type === "SAME" && d.shipment_ticket === trackingNumber) {
        setlatitude(Number(d.shipment_latitude));
        setlognitude(Number(d.shipment_longitude));
        setStatus(d.current_status);
      }
    }
  }, [trackingdata])

    const mapRef = useRef<MapRef | null>(null);

    useEffect(() => {
      setTimeout(()=>{
      if (mapRef.current) {
        if(mapRef.current){
          mapRef.current?.flyTo({
            center: [lognitude,latitude ], 
            zoom: 4, 
            speed: 2, 
            curve: 1,
          });
        }
        // });
      }
    },500)
    }, [latitude,lognitude,mapRef]);
  return (
    <div className="driver_mapdialog">
      <Map
        mapboxAccessToken="pk.eyJ1IjoiaW5zdGFkaXNwYXRjaCIsImEiOiJjazJvajJueWwwNjlmM2dwcHMxbTFiMHl0In0.9eyVqMCN3WIodGdslgQ1hA"
        initialViewState={{
          longitude: Number(driverlong ?? 0),
          latitude: Number(driverlat ?? 0),
          zoom: 4, 
        }}       
        style={{ width: 550, height: 450 }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        attributionControl={false}
        ref={mapRef}
      >
        <Marker longitude={Number(lognitude)} latitude={Number(latitude)} >
          {status === 'D' ? (
            <img src='./img/red-marker.png' alt="Marker"></img>
          ) : (

            <img src='./img/yellow-marker.png' alt="Marker"></img>
          )}
        </Marker>
        <Marker longitude={Number(driverlong)} latitude={Number(driverlat)}  >
          <img src='./img/mini-van-green.svg'></img>
        </Marker>
      </Map>
    </div>
  );
}
